// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--fo3iO","chat-container":"_93444fe79c--chat-container--hV4km","jump":"_93444fe79c--jump--joYmu"};